import { createRootRoute, createRoute, createRouter, Outlet } from '@tanstack/react-router';
import { LandingPage } from './routes/landing.js';
import { OnboardingStartPage } from './routes/onboarding-start.js';
import { AdminBootstrapPage } from './routes/admin.js';
import { LoginPage } from './routes/login.js';
import { DashboardPage } from './routes/dashboard.js';
import { OnboardingCompletePage } from './routes/onboarding-complete.js';

const rootRoute = createRootRoute({
  component: () => (
    <div className="min-h-screen flex flex-col">
      <Outlet />
    </div>
  ),
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: LandingPage,
});

const onboardingStartRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/onboarding/start',
  component: OnboardingStartPage,
});

const adminBootstrapRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin',
  component: AdminBootstrapPage,
});

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
});

const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dashboard',
  component: DashboardPage,
});

const onboardingCompleteRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/onboarding/complete/$token',
  component: OnboardingCompletePage,
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  onboardingStartRoute,
  adminBootstrapRoute,
  loginRoute,
  dashboardRoute,
  onboardingCompleteRoute,
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
